const env = import.meta.env.MODE;
const isDev = env === 'development' ? true : false;
//const recaptchaKey = '6LeV25YpAAAAAM3Myb0RwdQSZOJsjTArwF6YSHh_';
const recaptchaKey = '6LfIOvopAAAAAOPn4fkR67NrMQyRRqQy2fylAgY8';
export { env, isDev, recaptchaKey }
